import { render, staticRenderFns } from "./StopBase.vue?vue&type=template&id=1f1270f5&scoped=true&"
import script from "./StopBase.vue?vue&type=script&lang=ts&"
export * from "./StopBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1270f5",
  null
  
)

export default component.exports